import { render, staticRenderFns } from "./PageBuilderImageWidget.vue?vue&type=template&id=fdda85de"
import script from "./PageBuilderImageWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderImageWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports